import { render } from "./SignInButton.vue?vue&type=template&id=07edfe55"
import script from "./SignInButton.vue?vue&type=script&lang=js"
export * from "./SignInButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\toru-ota\\source\\repos\\Marron\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__